<template>
  <div class="report-print-header">
    <div class="report-print-brand">
      <img
        :src="logo"
        class="report-print-logo"
        width="140"
        height="52"
        style="width: 140px; height: 52px; object-fit: contain"
        alt="Logo da empresa"
      />
      <div>
        <h1>{{ title }}</h1>
        <p>{{ subtitle }}</p>
      </div>
    </div>

    <div class="report-print-meta-center">
      <span>
        <strong>Emitido em:</strong>
        {{ generatedAt }}
      </span>
    </div>

    <div class="report-print-metadata">
      <span><strong>Empresa:</strong> {{ company }}</span>
      <span><strong>Período:</strong> {{ period }}</span>
      <span><strong>Emitido por:</strong> {{ emitter }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportPrintHeader",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    logo: {
      type: String,
      required: true,
    },
    generatedAt: {
      type: String,
      required: true,
    },
    company: {
      type: String,
      required: true,
    },
    period: {
      type: String,
      required: true,
    },
    emitter: {
      type: String,
      required: true,
    },
  },
};
</script>
